import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="instructor-acknowledgement"
export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.element.addEventListener('cancel', (event) => {
      event.preventDefault();
    });
    this.element.showModal();
  }

  toggle(event) {
    this.buttonTarget.disabled = !event.target.checked;
  }
}
